import React from "react";
import {connect} from 'react-redux'

// @material-ui/icons
import MoreIcon from "@material-ui/icons/More";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import EmailIcon from "@material-ui/icons/Email";
import RoomIcon from "@material-ui/icons/Room";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PictureUpload from "components/CustomUpload/PictureUpload.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


// @material-ui/core components
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import FormControl from "@material-ui/core/FormControl";
// import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from '@material-ui/core/LinearProgress';

//companies
import {
  companySave,
  companiesFetch,
  companyFetch
} from 'actions/companies'

import {
  danger,
  success,
} from 'actions/notification'

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";

class Form extends React.Component {
  state={
    form:{
      companyId:0,
      address:'',
      description:'',
      email:'',
      name:'',
    }
  }
  componentDidMount(){
    //Fetch information if is edit form
    if(this.props.match.params.id)
    this.props.fetch(this.props.match.params.id)
      .then(e=>this.setState({
        ...this.state,
        form:{
          ...e
        }
      }));

  }
  //Submit form
  submit(e){
    if(e.preventDefault)
      e.preventDefault();
    this.props.save(this.state.form)
      .then(e=>{
        this.props.success(e.name+ ' '+(e.companyId?'Edited':'Added')+'!',4); 
        this.props.history.goBack()
      })
      .catch(e=>{this.props.danger(e+'',4);})
  }
  //OnChange action for all inputs and selects
  change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
  }

  /* {
    name:string //Displayed label
    key:string //value of state
    required:boolean //required validation
    icon:node //icon of input
  }*/
  getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>(required)</small>:data.required)}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key],
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
  }
  render() {
    const {classes,isFetching}=this.props;
    return (
          <GridContainer justify="center">
            <GridItem xs={12} sm={8}>
            <Card>
            <CardBody>
          
            {//Show progress onFetch
            (isFetching)         
            ?<LinearProgress/>
            :<form
              onSubmit={this.submit.bind(this)}
            >
              <GridContainer justify="center">
                {/*Header Information*/}
                <GridItem xs={12} sm={12}>
                  <h4 className={classes.infoText}>
                    Complete information
                  </h4>
                </GridItem>
                {/*Upload Picture input*/}
                <GridItem xs={12} sm={4}>
                  <PictureUpload />
                </GridItem>
                {/*Right 2 inputs*/}
                <GridItem xs={12} sm={6}>
                  {/*Name input*/}
                  {this.getInput({
                      key:'name',
                      name:'Name',
                      icon:<RecordVoiceOverIcon className={this.props.classes.inputAdornmentIcon}/>,
                      type:'text',
                      required:true
                      })}
                  {/*Email input*/}
                  {this.getInput({
                      key:'email',
                      name:'Email',
                      icon:<EmailIcon className={this.props.classes.inputAdornmentIcon}/>,
                      type:'email',
                      required:true
                      })}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    {/*Adress input*/}
                    {this.getInput({
                      key:'address',
                      name:'Adress',
                      icon:<RoomIcon className={this.props.classes.inputAdornmentIcon}/>,
                      type:'text',
                      required:false
                      })}
                    
                    {/*Description input*/}
                    {this.getInput({
                      key:'description',
                      name:'Description',
                      icon:<MoreIcon className={this.props.classes.inputAdornmentIcon}/>,
                      type:'textarea',
                      required:false
                      })}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <Button type="submit"  className={classes.submit} color="success">Submit</Button>
                  </GridItem>
              </GridContainer>
              </form>
            }
              </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
    );
  }
}
const mapStateToProps=(state,props)=>({
  isFetching:state.companies.isFetching,
  companyies:state.companies.list
})
const mapDispatchToProps=(dispatch)=>({
  fetch:(id)=>dispatch(companyFetch(id)),
  fetchAll:()=>dispatch(companiesFetch()),
  save:(data)=>dispatch(companySave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  success:(text,sec)=>dispatch(success(text,sec)),
})
export default withStyles(styles)(connect(mapStateToProps,mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./src/views/Companies/Form.jsx